import type { Types as SduiTypes } from '../types';
import type { OutTypes } from './schedules';

export default (
  schoolYear: SduiTypes.schoolYear
): OutTypes.division => {
  return {
    start: schoolYear.begins_at,
    end:   schoolYear.ends_at
  };
};
